import { PlatformID } from '@cloudnoa/cloud-platform';

function initVariables(defaultPlatform, defaultEnv = 'dev') {
  if (!window.servicePlatform) {
    window.servicePlatform = defaultPlatform;
  }

  if (!window.serviceEnv) {
    window.serviceEnv = defaultEnv;
  }
}

// 로컬 테스트시 여기에서 플랫폼을 변경하세요.
initVariables(PlatformID.GCP);

export default {
  // 로컬 테스트에 필요한 설정을 여기에 추가하세요.
  // 'admin.root': 'http://localhost:8000/admin/',
};
